import { useLazyQuery } from '@apollo/client/react';
import { isBefore } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback, useEffect } from 'react';

import { Modal } from '~/components/blocks';
import { GetAccessPermissionDocument, GetAccessPermissionQuery } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { permissionModalState } from '~/state/layouts/OrganizationAppShell/atoms';

import { AllowPane } from './AllowPane';
import { ForbidPane } from './ForbidPane';

const getExpiredAt = (data?: GetAccessPermissionQuery) => {
  if (!data) return null;

  const expiredAt = getMe(data)?.operatorAccessPermission?.expiresAt;

  if (!expiredAt) return null;

  const today = new Date();
  const expiredDate = new Date(expiredAt);

  return isBefore(today, expiredDate) ? expiredAt : null;
};

export const AccessPermissionModal = () => {
  const { isOpen } = useAtomValue(permissionModalState);
  const resetPermissionModalState = useResetAtom(permissionModalState);
  const [getAccessPermission, { data, loading }] = useLazyQuery(GetAccessPermissionDocument, {
    fetchPolicy: 'network-only',
  });
  const expiredAt = getExpiredAt(data);
  const handleClose = useCallback(() => {
    resetPermissionModalState();
  }, [resetPermissionModalState]);

  useEffect(() => {
    if (isOpen) {
      getAccessPermission();
    }
  }, [getAccessPermission, isOpen]);

  return (
    <Modal size="s" open={isOpen} onClose={handleClose}>
      <Modal.Header>アクセス許可</Modal.Header>
      {loading ? null : expiredAt ? <ForbidPane expiredAt={expiredAt} /> : <AllowPane />}
    </Modal>
  );
};
